import { z } from 'zod';
import { User } from '../../helpers/User';

export const schema = z.object({
  tempToken: z.string().min(1),
  token: z.string().min(6).max(9),
});

export type OutputType = {
  user: User;
};

export const postTotpChallenge = async (
  body: z.infer<typeof schema>,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/auth/totp-challenge', {
    method: 'POST',
    body: JSON.stringify(body),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    credentials: 'include',
  });

  if (!result.ok) {
    const errorData = await result.json();
    throw new Error(errorData.message || '2FA verification failed');
  }

  return result.json();
};
